import { Spinner } from "@timeghost/ui/shadcn/spinner";
import { CircleCheckIcon, InfoIcon, OctagonXIcon, TriangleAlertIcon } from "lucide-react";
import { type JSX, useEffect, useState } from "react";
import { Toaster as Sonner, type ToasterProps } from "sonner";
import {
	getStoredThemePreference,
	type ResolvedTheme,
	resolveThemePreference,
	THEME_CHANGE_EVENT,
	type ThemeChangeDetail,
} from "@/lib/theme";

const Toaster = (props: ToasterProps): JSX.Element => {
	const [theme, setTheme] = useState<ResolvedTheme>(() => resolveThemePreference(getStoredThemePreference()));

	useEffect(() => {
		const handleThemeChange = (event: Event): void => {
			const customEvent = event as CustomEvent<ThemeChangeDetail>;
			setTheme(customEvent.detail.resolvedTheme);
		};

		window.addEventListener(THEME_CHANGE_EVENT, handleThemeChange);

		return () => {
			window.removeEventListener(THEME_CHANGE_EVENT, handleThemeChange);
		};
	}, []);

	return (
		<Sonner
			className="toaster group"
			icons={{
				success: <CircleCheckIcon className="size-4" />,
				info: <InfoIcon className="size-4" />,
				warning: <TriangleAlertIcon className="size-4" />,
				error: <OctagonXIcon className="size-4" />,
				loading: <Spinner color="foreground" size="sm" />,
			}}
			style={
				{
					"--normal-bg": "var(--popover)",
					"--normal-text": "var(--popover-foreground)",
					"--normal-border": "var(--border)",
					"--border-radius": "var(--radius)",
				} as React.CSSProperties
			}
			theme={theme}
			toastOptions={{
				classNames: {
					toast: "cn-toast",
				},
			}}
			{...props}
		/>
	);
};

export default Toaster;
